export const UPDATE_SPOT_LIST_REQUEST = 'UPDATE_SPOT_LIST_REQUEST';

export const updateSpotListRequest = ( id: string, updateData: {} ) => ({
    type: UPDATE_SPOT_LIST_REQUEST,
    payload: { id, updateData }
});
